export const MAX_PIXELS_QUERY_PARAMS_LENGTH = 250;
export const MAX_SEGMENTS_QUERY_PARAMS_LENGTH = 250;
export const MAX_QUERY_PARAMS_LENGTH = 300;

export const MAX_BEESWAX_0_5_REQUEST_ROWS = 3000;
